module.exports = __webpack_public_path__ + "static/media/message.7cf8df1b.png";